export const filterConfig = [
    {
        id: 'dateRange',
        label: 'Booking Date Range',
        type: 'dateRange',
        format: 'DD-MM-YYYY',
        queryParamNames: {
            start: 'paymentStartDate',
            end: 'paymentEndDate',
        },
        quickFilters: ['today', 'yesterday', 'last7days', 'last30days'],
    },
    {
        id: 'bookingFor',
        label: 'Booking For',
        type: 'select',
        options: [
            { label: 'Appointment', value: 'Appointment' },
            { label: 'Service', value: 'Service' },
            { label: 'Solution', value: 'Solution' },
            { label: 'Treatment', value: 'Treatment' },
        ],
    },
    {
        id: 'orderStatus',
        label: 'Order Status',
        type: 'select',
        options: [
            { label: 'Initialize', value: 'Initialize' },
            { label: 'Confirmed', value: 'Confirmed' },
            { label: 'Completed', value: 'Completed' },
            { label: 'Cancelled', value: 'Cancelled' },
        ],
    },
    {
        id: 'paymentStatus',
        label: 'Payment Status',
        type: 'select',
        options: [
            { label: 'Pending', value: 'Pending' },
            { label: 'Completed', value: 'Completed' },
            { label: 'Failed', value: 'Failed' },
        ],
    },
    {
        id: 'paymentMode',
        label: 'Payment Mode',
        type: 'text',
    },
];

export const summaryConfig = [
    { field: 'amount', type: 'sum', label: 'Total Amount' },
    { field: 'updatedPaidAmount', type: 'sum', label: 'Total Paid' },
    { field: 'orderId', type: 'count', label: 'Total Orders' },
];

export const defaultSort = null;
